<div class="signature-pad" [class.signature-pad--fullpage]="fullPage">
  <canvas
    #canvas
    class="diary-signature-canvas block w-full touch-none"
    [class.diary-signature-canvas--fullpage]="fullPage"
    width="560"
    height="180"
    touch-action="none"
    (pointerdown)="onPointerDown($event)"
    (pointermove)="onPointerMove($event)"
    (pointerup)="onPointerUp($event)"
    (pointerleave)="onPointerLeave($event)"
    (pointercancel)="onPointerUp($event)"></canvas>
</div>
<div class="mt-2 flex justify-end shrink-0">
  <app-button variant="secondary" size="sm" (onClick)="clear()" [disabled]="disabled">
    Vymazat podpis
  </app-button>
</div>
